import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthState {
  username: string;
  password: string;
  accessToken: string;
  refreshToken: string;
  isLoading: boolean;
  isRefreshing: boolean;
  codigoVoluntario: string | null;
  userType: string | null;
  mustChangePassword: boolean;
  hydrated: boolean;
}

const initialState: AuthState = {
  username: '',
  password: '',
  accessToken: '',
  refreshToken: '',
  isLoading: false,
  isRefreshing: false,
  codigoVoluntario: null,
  userType: null,
  mustChangePassword: false,
  hydrated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUsername(state, action: PayloadAction<string>) {
      state.username = action.payload;
    },
    setPassword(state, action: PayloadAction<string>) {
      state.password = action.payload;
    },
    setAccessToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
      state.isLoading = false;
      state.isRefreshing = false;
    },
    setRefreshToken(state, action: PayloadAction<string>) {
      state.refreshToken = action.payload;
    },
    startRefreshingToken(state) {
      state.isRefreshing = true;
    },
    finishRefreshingToken(state, action: PayloadAction<string>) {
      state.accessToken = action.payload;
      state.isRefreshing = false;
    },
    clearAccessToken(state) {
      state.accessToken = '';
      state.refreshToken = '';
      state.codigoVoluntario = null;
      state.userType = null;
      state.mustChangePassword = false;
      state.isRefreshing = false;
      state.isLoading = false;
    },
    clearRefreshToken(state) {
      state.refreshToken = '';
    },
    setCodigoVoluntario(state, action: PayloadAction<string | null>) {
      state.codigoVoluntario = action.payload;
    },
    setUserType(state, action: PayloadAction<string | null>) {
      state.userType = action.payload;
    },
    setMustChangePassword(state, action: PayloadAction<boolean>) {
      state.mustChangePassword = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('persist/REHYDRATE' as any, (state) => {
      state.hydrated = true;
      state.isLoading = false;
      state.isRefreshing = false;
    });
  },
});

export const {
  setUsername,
  setPassword,
  setAccessToken,
  setRefreshToken,
  startRefreshingToken,
  finishRefreshingToken,
  clearAccessToken,
  clearRefreshToken,
  setCodigoVoluntario,
  setUserType,
  setMustChangePassword
} = authSlice.actions;

export default authSlice.reducer;
